module.exports = __webpack_public_path__ + "1e259a7283d517481be745f787661349.jpg";